// Lightweight ARIA live announcer to provide screen reader feedback across the app.
let liveRegion: HTMLDivElement | null = null;

function ensureRegion() {
  if (typeof document === 'undefined') return null;
  if (liveRegion) return liveRegion;
  const div = document.createElement('div');
  div.setAttribute('aria-live', 'polite');
  div.setAttribute('aria-atomic', 'true');
  div.setAttribute('role', 'status');
  div.style.position = 'fixed';
  div.style.bottom = '0';
  div.style.left = '0';
  div.style.width = '1px';
  div.style.height = '1px';
  div.style.padding = '0';
  div.style.overflow = 'hidden';
  div.style.clip = 'rect(0 0 0 0)';
  div.style.whiteSpace = 'nowrap';
  div.style.border = '0';
  document.body.appendChild(div);
  liveRegion = div;
  return liveRegion;
}

export function announce(message: string) {
  const region = ensureRegion();
  if (!region) return;
  // Clear then set to force announcement
  region.textContent = '';
  // Slight delay can improve reliability across browsers
  setTimeout(() => {
    if (liveRegion) liveRegion.textContent = message;
  }, 50);
}

export default { announce };
